/**
 * The sentence to show when `POST users/confirm-email` refused the change: the API's own message
 * when it sent one (PREC-4636: "This user holds the Admin role, and only an @signalist.io or
 * @digital-now.io account may hold it. …"), a generic one otherwise.
 */
export const confirmEmailRefusal = (error: unknown): string => {
	const data = (error as { data?: { message?: unknown } } | null)?.data;
	const message = Array.isArray(data?.message) ? data?.message[0] : data?.message;

	return typeof message === "string" && message.trim()
		? message
		: "The email address could not be changed. Please try again or contact support.";
};
